import { render, staticRenderFns } from "./ShowProgram.vue?vue&type=template&id=ccaf3ace&scoped=true"
import script from "./ShowProgram.vue?vue&type=script&lang=js"
export * from "./ShowProgram.vue?vue&type=script&lang=js"
import style0 from "./ShowProgram.vue?vue&type=style&index=0&id=ccaf3ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf3ace",
  null
  
)

export default component.exports